"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const Checkbox_1 = __importDefault(require("@Components/Selectors/Checkbox"));
const CheckboxGroupForm = ({ name, mainColor = true, registerOptions, checkboxes, defaultValue, size, labelInfo, rounded = false, readonly, children, }) => {
    const { control } = (0, react_hook_form_1.useFormContext)();
    // Handles adding/removing checkbox values in a concise, immutable way
    // Uses useCallback to avoid unnecessary re-renders
    const handleCheckboxChange = (0, react_1.useCallback)((checked, id, value, onChange) => {
        const valueCopy = value ? [...value] : [];
        const updated = checked
            ? [...valueCopy, id].filter((v, i, arr) => arr.indexOf(v) === i)
            : valueCopy.filter((item) => item !== id);
        onChange(updated);
    }, []);
    return (react_1.default.createElement(react_hook_form_1.Controller, { name: name, control: control, rules: registerOptions, defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : [], render: ({ field: { value, onChange } }) => (react_1.default.createElement(react_1.default.Fragment, null,
            checkboxes.map((checkbox, index) => {
                var _a;
                return (react_1.default.createElement(Checkbox_1.default, { key: checkbox.id || index, mainColor: mainColor, onClick: (state, id) => handleCheckboxChange(state, id, value, onChange), size: size, labelInfo: labelInfo, disabled: !!registerOptions && registerOptions.disabled, id: checkbox.id, checked: value ? value.includes(checkbox.id) : false, readonly: readonly, rounded: rounded }, (_a = checkbox.children) !== null && _a !== void 0 ? _a : checkbox.label));
            }),
            children)) }));
};
exports.default = CheckboxGroupForm;
